module.exports = __webpack_public_path__ + "static/img/success.b2e7034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/success.png
// module id = I59q
// module chunks = 1